import { APPEAL_TRANSLATIONS } from '@/_constants/translations';
import { EBlocksNames } from '@/_types';

export const getHeaderPopupLinks = (
  locale: string,
): Array<{ id: EBlocksNames; title: string; routeName: string }> => [
  {
    id: EBlocksNames.OFFER,
    title: APPEAL_TRANSLATIONS.header.terms,
    routeName: `/terms?locale=${locale}&country=ru`,
  },
  {
    id: EBlocksNames.ACCESS_RECOVERY,
    title: APPEAL_TRANSLATIONS.header.restoreAccess,
    routeName: `/appeal-without-login/${locale}`,
  },
];
